module.exports = __webpack_public_path__ + "img/media_bg.06e3a15d.jpg";